import React from 'react';
import { useTranslation } from 'react-i18next';

import { Node } from '@uncinc/react-drupal-core';

import { Button, Message, ViewArea } from '../../../../components';

const VacanciesOverview = (props) => {
  const {
    loading,
    header,
    entities,
    footer,
    viewId,
    display,
    pager,
    onLoadMore,
  } = props;

  const { t } = useTranslation();

  const type = viewId === 'internships' ? '' : 'error';

  const amountOfVacancies = pager.get('total_items');

  const isAllLoaded = amountOfVacancies === entities.size;

  /**
   * We want to distinguish between loading that is a result of using the paginator and
   * using the filter, since we do not want to show a loading screen when loading more.
   */
  const [isLoadingFromPaginator, setIsLoadingFromPaginator] = React.useState(false);

  function onLoadMoreButtonClicked() {
    setIsLoadingFromPaginator(true);
    onLoadMore();
  }

  React.useEffect(() => {
    if (!loading && isLoadingFromPaginator) {
      setIsLoadingFromPaginator(false);
    }
  }, [isLoadingFromPaginator, loading]);

  if (loading && !isLoadingFromPaginator) {
    return null;
  }

  return (
    <div className="VacanciesOverview">
      <div className="ViewWithFilters__section-title">
        {(amountOfVacancies > 0 && display !== 'vacancies_for_department' && <h5>{amountOfVacancies} vacatures</h5>)}
      </div>

      <ViewArea>
        {header}
      </ViewArea>

      {entities.size > 0 ? entities.map((entity) => {
        const id = entity.getIn(['nid', '0', 'value']);
        const uuid = entity.getIn(['uuid', 0, 'value']);
        const langcode = entity.getIn(['langcode', 0, 'value']);

        return (
          <Node
            id={id}
            key={`${uuid}:${langcode}`}
            isActivePath
            entity={entity}
            viewMode="teaser"
          />
        );
      }) : (
        <Message type={type} className="u-margin--bottom--5">
          {t(`views.no_results.${viewId}.${display}`)}
          {viewId === 'internships' && (
            <a href={t('views.no_results.internships.url')}>
              {t('views.no_results.internships.link')}
            </a>
          )}
        </Message>
      )}

      {!isAllLoaded && (
        <div className="VacanciesOverview__show-more-container">
          <Button type="secondary" onClick={() => onLoadMoreButtonClicked()} icon="arrow_downward" isLoading={loading}>
            {t('views.show_more')}
          </Button>
        </div>
      )}

      <ViewArea>
        {footer}
      </ViewArea>
    </div>
  );
};

export default VacanciesOverview;
